<template>
  <span class="design-preview" aria-hidden="true">
    <i v-for="row in 4" :key="row" class="dp-line"><b></b></i>
  </span>
</template>

<script>
// The classic design's thumbnail in the ride-settings picker: a list of days.
export default {
  name: 'ClassicPreview',
};
</script>

<style scoped>
.design-preview {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  height: 92px;
  padding: 8px 10px;
  border-radius: 10px;
  background: #f4f3f0;
  overflow: hidden;
  direction: ltr;
}

.design-preview i,
.design-preview b {
  display: block;
  font-style: normal;
}

.dp-line b {
  height: 8px;
  width: 55%;
  border-radius: 4px;
  background: #c9c9c9;
}

.dp-line:first-child b {
  width: 35%;
  background: var(--primary-background, #07A0C3);
}
</style>
